import { Spinner } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { ManagerAuthorization } from '@common/enums/managerAuthorization';
import { UserTextParagraph } from '@frontend/components/elements/common';
import { FormLabel } from '@frontend/components/elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '@frontend/components/elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '@frontend/components/elements/forms/InputContainer';
import { getJson } from '@frontend/store/fetch';
import { getSelectedLanguage } from '@frontend/translate';
import { assertHasAuthorization } from '@frontend/utils/assertHasAuthorization';

interface IWatchPatSerialNumberProps {
    requestId: string;
}

export function WatchPatSerialNumber(props: IWatchPatSerialNumberProps) {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [serialNumber, setSerialNumber] = useState<string>();

    assertHasAuthorization(ManagerAuthorization.adminProcessRead);

    useEffect(() => {
        const getSerialNumber = async () => {
            setIsLoading(true);

            const watchPatSerialNumber = await fetchSerialNumber(props.requestId);

            setSerialNumber(watchPatSerialNumber);
            setIsLoading(false);
        };

        getSerialNumber();
    }, []);

    return (
        <HorizontalFormGroupRead>
            <FormLabel>WatchPAT serienummer</FormLabel>
            {isLoading ? (
                <Spinner style={{ marginTop: 'var(--kds-spacing-2' }} />
            ) : (
                <InputContainer>
                    <UserTextParagraph>{serialNumber}</UserTextParagraph>
                </InputContainer>
            )}
        </HorizontalFormGroupRead>
    );
}

async function fetchSerialNumber(requestId: string) {
    try {
        const response = await getJson<Record<'serialNumber', string | null>>(
            `/api/cloudpat/watchPatSerialNumber/${requestId}`
        );

        return response.json?.serialNumber ?? getSelectedLanguage().osas.watchPatSerialNumberNotFilledIn;
    } catch (e) {
        return getSelectedLanguage().osas.watchPatGetSerialNumberError;
    }
}
